import axios from 'axios'
import qs from 'querystring'

const xApiKey = process.env.REACT_APP_X_API_KEY

axios.interceptors.request.use(
  config => {
    const headerConfig = config
    headerConfig.headers['x-api-key'] = xApiKey
    return headerConfig
  },
  error => Promise.reject(error)
)

const host = process.env.REACT_APP_API_HOST

export const loginService = async (username, password) => {
  const bearerLoginURL = process.env.REACT_APP_API_BEARER_LOGIN_URL
  const dataLoginURL = process.env.REACT_APP_API_LOGIN_DATA_URL
  const clientSecretKey = process.env.REACT_APP_CLIENT_SECRET_KEY

  const body = {
    client_id: 'apiconnect',
    client_secret: clientSecretKey,
    grant_type: 'password',
    username,
    password,
    scope: 'securityapi',
  }
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }
  const response = await axios.post(bearerLoginURL, qs.stringify(body), config)

  const authStr = 'Bearer '.concat(response.data.access_token)

  const aplicationcode = process.env.REACT_APP_APLICATION_CODE

  const userResponse = await axios.get(dataLoginURL, {
    headers: { Authorization: authStr },
    params: {
      aplicationcode,
      countrycode: 'PE',
      locationcode: 0,
      profilecode: 0,
      username,
    },
  })
  const {
    status,
    data: { userfullname },
  } = userResponse

  return { status, userfullname, userAuthKey: response.data.access_token }
}

export const fetchData = async ({
  sku = '',
  order = '',
  orden = '',
  dni = '',
  sucursal = '',
  dateStart = '',
  dateEnd = '',
  page = '',
  size = '',
  userAuthKey = '',
  action = '',
  barcodeString = '',
  transaction = '',
  dateTransaction = '',
  caja = '',
  view = '',
}) => {
  if (!userAuthKey) throw new Error('User Key no encontrada')
  const postURL = action ? `${host}/api/${view}?action=${action}` : `${host}/api/${view}`

  const body = {
    ...(sku && { sku }),
    ...(order && { orden: order }),
    ...(orden && { orden }),
    ...(dni && { dni }),
    ...(sucursal && { sucursal }),
    ...(parseInt(page, 10) > -1 && { page: `${parseInt(page, 10) + 1}` }),
    ...(parseInt(size, 10) > 0 && { size }),
    ...(dateStart && { fechainicio: dateStart }),
    ...(dateEnd && { fechafin: dateEnd }),
    ...(barcodeString && { serial: barcodeString }),
    ...(transaction && { transaccion: transaction }),
    ...(dateTransaction && { fecha_trunc: dateTransaction }),
    ...(caja && { caja }),
  }

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-token': `${userAuthKey}`,
      // 'Access-Control-Allow-Origin': '*',
    },
  }

  const result = await axios.post(postURL, JSON.stringify(body), config)
  return result
}
